/**
 * Блок «Комиссия в RCC» под доходом в «Проверьте сами» (RccCommission.tsx).
 */
export interface RccTranslations {
    toExchange: string
    toExchangeHint: string
    fee: string
    feeHint: string
    stays: string
    growTitle: string
    growText: string
    buyPrice: string
    nowPrice: string
    tokensDay: string
    costDay: string
    feePct: string
    growth: string
    rate: string
    note: string
}

const ru: RccTranslations = {
    toExchange: 'На счёт биржи',
    toExchangeHint: 'вся прибыль робота, в день',
    fee: 'Комиссия 50% в RCC',
    feeHint: 'в день по курсу {price}',
    stays: 'Депозит и вся прибыль остаются на бирже. Комиссия списывается токенами RCC с отдельного баланса на платформе.',
    growTitle: 'Как рост цены RCC снижает комиссию',
    growText:
        'Комиссия считается в долларах и списывается в RCC по текущему курсу: чем дороже RCC, тем меньше токенов уходит. Для токенов, купленных раньше, комиссия = 50% ÷ рост курса. Купили по 3,5 $, курс стал 35 $ (×10) — комиссия для вас 5%.',
    buyPrice: 'Цена покупки RCC',
    nowPrice: 'Курс RCC',
    tokensDay: 'Спишется в день',
    costDay: 'Стоит вам по цене покупки',
    feePct: 'Комиссия для вас',
    growth: 'Рост',
    rate: 'Курс',
    note: 'Пример, не прогноз. Курс RCC идёт за TRX (1 RCC = 10 TRX) и может снижаться — тогда токенов списывается больше.',
}

const en: RccTranslations = {
    toExchange: 'To the exchange account',
    toExchangeHint: 'all of the robot\'s profit, per day',
    fee: '50% fee in RCC',
    feeHint: 'per day at {price}',
    stays: 'Your deposit and all profit stay on the exchange. The fee is charged in RCC tokens from a separate balance on the platform.',
    growTitle: 'How a rising RCC price lowers the fee',
    growText:
        'The fee is counted in dollars and charged in RCC at the current rate: the more RCC costs, the fewer tokens go. For tokens bought earlier, the fee = 50% ÷ price growth. Bought at $3.5, the rate is now $35 (×10) — your fee is 5%.',
    buyPrice: 'RCC purchase price',
    nowPrice: 'RCC rate',
    tokensDay: 'Charged per day',
    costDay: 'Costs you at purchase price',
    feePct: 'Your fee',
    growth: 'Growth',
    rate: 'Rate',
    note: 'An example, not a forecast. The RCC rate follows TRX (1 RCC = 10 TRX) and can fall — then more tokens are charged.',
}

const es: RccTranslations = {
    toExchange: 'A la cuenta del exchange',
    toExchangeHint: 'todo el beneficio del robot, por día',
    fee: 'Comisión del 50% en RCC',
    feeHint: 'por día a {price}',
    stays: 'El depósito y todo el beneficio se quedan en el exchange. La comisión se cobra en tokens RCC de un saldo aparte en la plataforma.',
    growTitle: 'Cómo la subida de RCC reduce la comisión',
    growText:
        'La comisión se calcula en dólares y se cobra en RCC al precio actual: cuanto más vale RCC, menos tokens se van. Para tokens comprados antes, la comisión = 50% ÷ subida del precio. Comprados a 3,5 $, ahora valen 35 $ (×10): su comisión es del 5%.',
    buyPrice: 'Precio de compra de RCC',
    nowPrice: 'Precio de RCC',
    tokensDay: 'Se cobra por día',
    costDay: 'Le cuesta al precio de compra',
    feePct: 'Su comisión',
    growth: 'Subida',
    rate: 'Precio',
    note: 'Un ejemplo, no un pronóstico. El precio de RCC sigue a TRX (1 RCC = 10 TRX) y puede bajar; entonces se cobran más tokens.',
}

const fr: RccTranslations = {
    toExchange: 'Sur le compte de la plateforme',
    toExchangeHint: 'tout le profit du robot, par jour',
    fee: 'Commission de 50 % en RCC',
    feeHint: 'par jour au cours de {price}',
    stays: 'Le dépôt et tout le profit restent sur la plateforme. La commission est prélevée en jetons RCC sur un solde séparé.',
    growTitle: 'Comment la hausse du RCC réduit la commission',
    growText:
        'La commission est calculée en dollars et prélevée en RCC au cours actuel : plus le RCC est cher, moins il part de jetons. Pour des jetons achetés plus tôt, la commission = 50 % ÷ hausse du cours. Achetés à 3,5 $, le cours passe à 35 $ (×10) : votre commission est de 5 %.',
    buyPrice: 'Prix d\'achat du RCC',
    nowPrice: 'Cours du RCC',
    tokensDay: 'Prélevé par jour',
    costDay: 'Vous coûte au prix d\'achat',
    feePct: 'Votre commission',
    growth: 'Hausse',
    rate: 'Cours',
    note: 'Un exemple, pas une prévision. Le cours du RCC suit le TRX (1 RCC = 10 TRX) et peut baisser — il part alors plus de jetons.',
}

const de: RccTranslations = {
    toExchange: 'Aufs Börsenkonto',
    toExchangeHint: 'der ganze Gewinn des Roboters, pro Tag',
    fee: '50 % Gebühr in RCC',
    feeHint: 'pro Tag zum Kurs {price}',
    stays: 'Einlage und gesamter Gewinn bleiben an der Börse. Die Gebühr wird in RCC-Token von einem separaten Guthaben abgebucht.',
    growTitle: 'Wie ein steigender RCC-Kurs die Gebühr senkt',
    growText:
        'Die Gebühr wird in Dollar berechnet und in RCC zum aktuellen Kurs abgebucht: Je teurer RCC, desto weniger Token. Für früher gekaufte Token gilt: Gebühr = 50 % ÷ Kursanstieg. Gekauft zu 3,5 $, Kurs jetzt 35 $ (×10) — Ihre Gebühr beträgt 5 %.',
    buyPrice: 'RCC-Kaufpreis',
    nowPrice: 'RCC-Kurs',
    tokensDay: 'Abbuchung pro Tag',
    costDay: 'Kostet Sie zum Kaufpreis',
    feePct: 'Ihre Gebühr',
    growth: 'Anstieg',
    rate: 'Kurs',
    note: 'Ein Beispiel, keine Prognose. Der RCC-Kurs folgt TRX (1 RCC = 10 TRX) und kann fallen — dann werden mehr Token abgebucht.',
}

const it: RccTranslations = {
    toExchange: 'Sul conto dell\'exchange',
    toExchangeHint: 'tutto il profitto del robot, al giorno',
    fee: 'Commissione del 50% in RCC',
    feeHint: 'al giorno al prezzo di {price}',
    stays: 'Il deposito e tutto il profitto restano sull\'exchange. La commissione viene addebitata in token RCC da un saldo separato.',
    growTitle: 'Come la crescita di RCC riduce la commissione',
    growText:
        'La commissione è calcolata in dollari e addebitata in RCC al prezzo attuale: più costa RCC, meno token vengono addebitati. Per token comprati prima, la commissione = 50% ÷ crescita del prezzo. Comprati a 3,5 $, ora 35 $ (×10): la sua commissione è del 5%.',
    buyPrice: 'Prezzo di acquisto RCC',
    nowPrice: 'Prezzo RCC',
    tokensDay: 'Addebitato al giorno',
    costDay: 'Le costa al prezzo d\'acquisto',
    feePct: 'La sua commissione',
    growth: 'Crescita',
    rate: 'Prezzo',
    note: 'Un esempio, non una previsione. Il prezzo di RCC segue TRX (1 RCC = 10 TRX) e può scendere: allora si addebitano più token.',
}

const hy: RccTranslations = {
    toExchange: 'Բորսայի հաշվին',
    toExchangeHint: 'ռոբոտի ամբողջ շահույթը, օրական',
    fee: '50% միջնորդավճար RCC-ով',
    feeHint: 'օրական՝ {price} փոխարժեքով',
    stays: 'Ավանդը և ամբողջ շահույթը մնում են բորսայում։ Միջնորդավճարը գանձվում է RCC թոքեններով՝ հարթակի առանձին հաշվեկշռից։',
    growTitle: 'Ինչպես է RCC-ի գնի աճը նվազեցնում միջնորդավճարը',
    growText:
        'Միջնորդավճարը հաշվվում է դոլարով և գանձվում RCC-ով ընթացիկ փոխարժեքով՝ որքան թանկ է RCC-ն, այնքան քիչ թոքեն է գնում։ Ավելի վաղ գնված թոքենների համար միջնորդավճարը = 50% ÷ գնի աճ։ Գնել եք 3,5 $-ով, փոխարժեքը դարձել է 35 $ (×10)՝ ձեր միջնորդավճարը 5% է։',
    buyPrice: 'RCC-ի գնման գին',
    nowPrice: 'RCC-ի փոխարժեք',
    tokensDay: 'Գանձվում է օրական',
    costDay: 'Արժե ձեզ գնման գնով',
    feePct: 'Ձեր միջնորդավճարը',
    growth: 'Աճ',
    rate: 'Փոխարժեք',
    note: 'Օրինակ է, ոչ թե կանխատեսում։ RCC-ի փոխարժեքը հետևում է TRX-ին (1 RCC = 10 TRX) և կարող է նվազել՝ այդ դեպքում ավելի շատ թոքեն է գանձվում։',
}

const rccTranslations: Record<string, RccTranslations> = {
    ru,
    en,
    es,
    fr,
    de,
    it,
    hy,
}

export default rccTranslations
